import Link from "next/link";
import clsx from "clsx";
import Icon from "./Icon";

export default function Button({
  children,
  href,
  onClick,
  variant = "primary",
  size = "base",
  type = "button",
  icon,
  className,
  ...props
}) {
  const baseStyles = "rounded-full font-medium shadow transition";

  const variants = {
    primary:
      "bg-brand-primary border border-2 border-brand-primary text-white hover:bg-brand-primaryDarker hover:border-brand-primaryDarker inline-block",
    secondary:
      "bg-transparent border border-2 border-brand-text text-brand-text font-semibold hover:bg-brand-text hover:text-white inline-block",
    circle: "bg-transparent border-0 shadow-none",
    circlePrimary: "bg-brand-primary border-0 text-white shadow-none",
  };

  const sizes =
    variant === "circle" || variant === "circlePrimary"
      ? {
          base: "w-[32px] h-[32px]",
          small: "w-[40px] h-[40px]",
          large: "w-[50px] h-[50px]",
        }
      : {
          base: "py-2 px-6 text-base",
          small: "py-1 px-4 text-sm",
          large: "py-3 px-7 text-lg",
        };

  const combined = clsx(baseStyles, variants[variant], sizes[size], className);

  const isInternal = href && href.startsWith("/");

  if (href) {
    if (isInternal) {
      return (
        <Link href={href} scroll={false} className={combined} {...props}>
          {children}
        </Link>
      );
    }

    return (
      <a
        href={href}
        className={combined}
        target="_blank"
        rel="noopener noreferrer"
        {...props}
      >
        {children}
      </a>
    );
  }
  <Icon name="menu" />;
  return (
    <button type={type} onClick={onClick} className={combined} {...props}>
      {variant === "circle" || variant === "circlePrimary" ? (
        <Icon className="m-auto" name={icon} />
      ) : (
        children
      )}
    </button>
  );
}
